// extracted by mini-css-extract-plugin
export var fileUploadWrapper = "FileUpload-module__fileUploadWrapper___mShNQ";
export var content = "FileUpload-module__content___xNQd0";
export var body = "FileUpload-module__body___XOp2f";
export var hidden = "FileUpload-module__hidden___leG7z";
export var fileName = "FileUpload-module__fileName___WXJkc";
export var fileDetails = "FileUpload-module__fileDetails___O89Ad";